import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ModelsPage } from '@/features/ml/models/models-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Entrée « Modèles » de la navigation : le registre de modèles du tenant (porting README #83). */
export const Route = createFileRoute('/$tenant/models/')({ component: ModelsRoute });

function ModelsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="models" crumbs={[{ label: t('nav.items.models') }]}>
      <ModelsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
